




















































import Vue from 'vue';
import Component from 'vue-class-component';
import VueApexCharts from 'vue-apexcharts';
import moment from 'moment';
import { ticketsDashboard } from '@/modules/shared/shared/store/namespaces';

@Component({
    name: 'tickets-by-type',
    components: {
        apexchart: VueApexCharts,
    },
})
export default class TicketsByType extends Vue {
    @ticketsDashboard.State('tickets') tickets;

    get isLoading(): boolean {
        return !this.tickets;
    }

    get chartType(): string {
        return 'bar';
    }

    get chartOptions() {
        const fontFamily = 'Roboto, sans-serif';

        let config: object = {
            chart: {
                defaultLocale: 'es',
                type: this.chartType,
                fontFamily,
                stacked: true,
                dropShadow: {
                    enabled: true,
                    blur: 5,
                    opacity: 0.2,
                },
                toolbar: {
                    show: false,
                },
                locales: [
                    {
                        name: 'es',
                    },
                ],
            },
            dataLabels: {
                enabled: true,
                offsetY: -5,
                style: {
                    fontSize: '0.70rem',
                    fontFamily,
                    fontWeight: 300,
                    colors: ['#fff', '#000', '#fff', '#000', '#fff', '#000'],
                },
                dropShadow: {
                    enabled: true,
                    blur: 1,
                    bottom: 1,
                    opacity: 0.4,
                },
            },
            colors: ['#0154a6', '#ab2e92', '#60bb46', '#f26935', '#603e99', '#f9a31b'],
            legend: {
                show: true,
                position: 'bottom',
                horizontalAlign: 'center',
            },
            fill: {
                type: 'gradient',
                gradient: {
                    type: 'vertical',
                    shade: 'light',
                    shadeIntensity: 0.24,
                    inverseColors: true,
                },
            },
            stroke: {
                width: 1,
                curve: 'smooth',
            },
            grid: {
                borderColor: '#9598a6',
            },
            xaxis: {
                categories: [],
            },
        };

        if (!this.isLoading) {
            config = {
                ...config,
                xaxis: {
                    categories: this.chartData.categories,
                    labels: {
                        rotate: -45,
                        rotateAlways: true,
                        style: {
                            fontSize: '0.75rem',
                        },
                    },
                },
                yaxis: {
                    labels: {
                        style: { fontSize: '0.75rem' },
                    },
                    title: {
                        text: 'Cantidad de Tickets',
                    },
                },
                tooltip: {
                    enabled: true,
                    x: {
                        show: true,
                        formatter: (val: string, series: any): string => {
                            let tooltip: string = val;
                            try {
                                const sIdx =
                                    series.w.config.series[series.seriesIndex].indices[
                                        series.dataPointIndex
                                    ];

                                tooltip = moment(sIdx, 'M-YYYY')
                                    .locale('es')
                                    .format('MMMM YYYY');
                            } catch (err) {
                                // Nada por los momentos...
                            }

                            return tooltip;
                        },
                    },
                },
            };
        }

        return config;
    }

    public months = 12;

    // get filteredCategories() {
    //     return this.dataToShow.categories.slice(-this.months);
    // }

    get chartData(): {
        categories: string[];
        series: { name: string; data: number[]; indices: string[] }[];
    } {
        const result: {
            categories: string[];
            series: { name: string; data: number[]; indices: string[] }[];
        } = {
            categories: [],
            series: [],
        };

        try {
            if (!this.isLoading) {
                const categories = this.getChartCategories(this.months);

                this.tickets.values.ticketsTypesRecord.forEach(item => {
                    let idx = result.series.findIndex(serie => {
                        return serie.name === item.ticketType;
                    });

                    if (idx === -1) {
                        const data: number[] = new Array(categories.length);
                        idx = result.series.push({
                            name: item.ticketType,
                            data: data.fill(0),
                            indices: categories.map(category => {
                                return `${category.month}-${category.year}`;
                            }),
                        });
                        idx--;
                    }

                    const dataIdx = result.series[idx].indices.indexOf(
                        `${item.month}-${item.year}`,
                    );

                    if (dataIdx !== -1) {
                        result.series[idx].data[dataIdx] = item.total;
                    }
                });

                result.categories = categories.map(category => {
                    return moment()
                        .month(category.month - 1)
                        .locale('es')
                        .format('MMM');
                });
            }
        } catch (err) {
            // Nada por los momentos...
            //console.error(err);
        }

        return result;
    }

    getChartCategories(monthsFromNow): { display: string; month: number; year: number }[] {
        let categories: { display: string; month: number; year: number }[] = [];
        const dateStart = moment()
            .subtract(monthsFromNow - 1, 'month')
            .locale('es');

        while (monthsFromNow-- > 0) {
            categories.push({
                display: dateStart.format('MMMM YYYY'),
                month: parseInt(dateStart.format('M')),
                year: parseInt(dateStart.format('YYYY')),
            });
            dateStart.add(1, 'month');
        }

        return categories;
    }
}
